import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createQueryDefinition, createQueryHook } from '../queryBuilder';

import { keys as keysFn, get as getFn, update as updateFn, oldKeys, oldGet } from './api';

export const GetConfigKeysQuery = createQueryDefinition(
  (isNewConfigUapiEnabled: boolean) => ['config', 'keys', isNewConfigUapiEnabled] as const,
  ({ queryKey: [, , isNewConfigUapiEnabled] }) => (isNewConfigUapiEnabled ? keysFn() : oldKeys()),
);

export const useConfigKeysQuery = createQueryHook(GetConfigKeysQuery, {
  select: ({ data }) => data,
});

export const queryGetConfig = createQueryDefinition(
  (eventId: string | number, isNewConfigUapiEnabled: boolean) =>
    ['config', String(eventId), isNewConfigUapiEnabled] as const,
  ({ queryKey: [, eventId, isNewConfigUapiEnabled] }) =>
    isNewConfigUapiEnabled ? getFn(eventId) : oldGet(eventId),
);

export const useConfigQuery = createQueryHook(queryGetConfig, {
  select: ({ data }) => data,
});

export const useConfigUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      eventId,
      configs,
    }: {
      eventId: string;
      configs: { keyId: string; value: string | number; expiresAt?: string | null }[];
    }) => updateFn(eventId, configs),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['config'] });
    },
  });
};
